export default __webpack_public_path__ + "static/media/tie.1da5aefa.svg";